export const environment = {
    production: false,
    apiUrl: 'https://dev.api.tridimo.de/api/',
    webSocket: 'https://dev.api.tridimo.de',
    useTokenAuth: true
};